import createErrors from '../createErrors';
import { type Page } from './constants';

export type Component = 'OrdersPage';

/**
 * Errors related to the Order History page
 */
export const Errors = createErrors<Page, Component>('OrderHistory')({
    OrdersPage: {
        FetchFailed: {
            severity: 'MEDIUM',
            message: 'Failed to fetch orders',
        },
    },
});
